import React from 'react';

export default function StyleButton({type, label, onToggle, active}) {

    const className = (active ? ' active' : '');

    const onMouseDown = ev => {
        ev.preventDefault();

        onToggle(type);
    };

    return <button
        type="button"
        className={className}
        onMouseDown={onMouseDown}
    >
        {label}
    </button>;
}
